function isToggleActive(toggle, selector = ".combo_frame") {
	const toggles = getToggles(selector);
	return toggles[toggle] === true;
}

function getToggles(selector) {
	const moduleContainer = document.querySelector(selector);
	const rawToggles = moduleContainer?.dataset.toggles || "{}";
	try {
		return JSON.parse(rawToggles);
	} catch {
		return {};
	}
}

export default isToggleActive;
